import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    VerificationService,
    SuccessResponse,
    LogoComponent,
    CopyToClipboard,
} from '@sheerid/jslib';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    // eslint-disable-next-line
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    <div>
                        <LogoComponent verificationService={verificationService} />
                    </div>
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle-success sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage="Here is your personal promo code. It is unique to you and can only be used once." />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy promo code" />
                </CopyToClipboard>
            </div>
            <div className="sid-emailed-copy-footer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage="We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com" />
            </div>

            <div>
                <button
                    id="sid-step-success-botton"
                    type="submit"
                    className="sid-btn sid-btn--dark sid-l-full-width sid-button-add-link"
                    aria-label="submit"
                    onClick={() => window.open('https://www.dockers.com/')}
                >
                    <FormattedHTMLMessage id="step.success.continueButton" />
                </button>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage
                    id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only.
                        Now that you've been approved, please direct all questions about the
                        promotion terms and/or code use to Dockers customer service.
                    `}
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
